module.exports = __webpack_public_path__ + "img/footer-background.eac14d38.jpg";